import React, { useContext } from 'react'
import { AppContext } from '../../../App'

export default function HtnLogger(){
     const {state, dispatch} = useContext(AppContext);
   
    return (
    <a className="inlineBlock">Id. Correlacion: <span id="lblIdCorrelacion">{state.idCorrelacion}</span></a>
    )
}